import React from 'react'
import { 
    Icon, 
} from 'antd'
import './Summary.scss'
import { firestore } from '../../../service/firebase'

import { Line } from 'react-chartjs-2'

const data = {
    labels: ['October', 'November', 'December', 'January', 'February', 'March', 'April'],
    datasets: [{
        label: 'Monthly App Usage',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [1, 2, 3, 3, 3, 5, 6],
    }],
}
  
  
export default class Summary extends React.Component {
    
    summary = []
    infoList = []
    dataList = []

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadSummary()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadSummary() {
        firestore.collection('AppUser').get()
        .then(snapshot => {

            let docs = snapshot.docs
            let iOSUser = 0
            let androidUser = 0
            let lastDay = 0
            let lastMonth = 0
            let lastYear = 0

            docs.forEach(doc => {
                let data = doc.data()
                let platform = data['platform'].toLowerCase()
                if(platform === 'android') {
                    androidUser++
                } else if (platform === 'ios') {
                    iOSUser++
                }

                let installed = new Date(data['installed']['seconds'] * 1000)
                console.log(installed)
                let current = new Date()

                if(current.getFullYear() - installed.getFullYear() <= 1) {
                    lastYear++;
                }

                if(current.getMonth() - installed.getMonth() <= 1) {
                    lastMonth++;
                }

                if(current.getDate() - installed.getDate() <= 1) {
                    lastDay++;
                }
            })

            this.summary = [{
                title: 'Active User',
                icon: "user",
                value: docs.length,
            }, {
                title: 'iOS User',
                icon: "apple",
                value: iOSUser,
            }, {
                title: 'Android User',
                icon: "android",
                value: androidUser,
            }]

            this.infoList = [{
                title: 'Last Day',
                value: lastDay,
            }, {
                title: 'Last Month',
                value: lastMonth,
            }, {
                title: 'Last Year',
                value: lastYear,
            }]

            this.forceUpdate()
        })

        firestore.collection('User')
        .get()
        .then(result => {
            this.dataList.push({
                value: result.docs.length,
                title: 'Subscribed Users',
            })
            this.forceUpdate()
        })

        firestore.collection('Events')
        .get()
        .then(result => {
            this.dataList.push({
                value: result.docs.length,
                title: 'Events',
            })
            this.forceUpdate()
        })

        firestore.collection('Images')
        .get()
        .then(result => {
            this.dataList.push({
                value: result.docs.length,
                title: 'Pictures & Images',
            })
            this.forceUpdate()
        })

    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
    
    render() {

        return (
            <div className="summary">

                <div className="row-panel">
                {
                    this.summary.map((summary, index) => {
                        return (
                            <div key={index} className="user-summary-panel panel">
                                <div className="icon">
                                    <Icon type={summary.icon} style={{fontSize: 56, color: '#FFF'}}/>
                                </div>
                                <div>
                                    <p>{summary.value}</p>
                                    <span>{summary.title}</span>
                                </div>
                            </div>
                        )
                    })
                }
                </div>

                <div className="row-panel" style={{marginTop: 20}}>
                    <div className="graph panel">
                        <Line data={data} />
                    </div>

                    <div className="info">

                        <div className="panel" style={{padding: 20}}>
                            <div className="title">Installed by Users</div>
                            {
                                this.infoList.map((info, index) => {
                                    return (
                                        <div key={index} className="info-item">
                                            <div className="value">{info.value}</div>
                                            <div className="content">Users / {info.title}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div className="panel" style={{padding: 20}}>
                            <div className="title">Statistics</div>
                            {
                                this.dataList.map((item, index) => {
                                    return (
                                        <div key={index} className="info-item">
                                            <div className="value">{item.value}</div>
                                            <div className="content">{item.title}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>

                </div>

            </div>
        )
    }
}
